import { useTranslation } from "react-i18next";

import BaseSkeleton from "@/components_v2/Skeleton/BaseSkeleton";
import BaseSkeletonGroup from "@/components_v2/Skeleton/BaseSkeletonGroup";
import { SKELETON_VARIANTS } from "@/components_v2/Skeleton/constants";

import "@/domains/certifications/components/styles.css";
import "../styles.css";

const GAIN_CARDS = 3;
const PATH_CARDS = 2;

const DetailsSkeleton = () => {
  const { t } = useTranslation();

  return (
    <BaseSkeletonGroup
      label={t("labels.loading")}
      className="certification-details-page"
    >
      <BaseSkeleton height="22rem" />

      <div className="certification-details-content flex flex-col gap-800">
        <section className="flex flex-col gap-400">
          <BaseSkeleton width="14rem" height="var(--spacing-500)" />

          <div className="certification-card-row flex flex-wrap gap-300">
            {Array.from({ length: GAIN_CARDS }, (_, index) => (
              <BaseSkeleton key={index} height="9rem" />
            ))}
          </div>
        </section>

        <section className="flex flex-col gap-400">
          <BaseSkeleton width="16rem" height="var(--spacing-500)" />

          <div className="certification-card-row flex flex-wrap gap-400">
            {Array.from({ length: PATH_CARDS }, (_, index) => (
              <div
                key={index}
                className="certification-card certification-details-skeleton-card flex flex-col gap-300"
              >
                <BaseSkeleton height="var(--spacing-600)" />

                <BaseSkeleton variant={SKELETON_VARIANTS.TEXT} lines={4} />
              </div>
            ))}
          </div>
        </section>
      </div>
    </BaseSkeletonGroup>
  );
};

export default DetailsSkeleton;
